import React from 'react';
import BannerAd from 'ads/BannerAd';
import SearchResultsContainer from './search/SearchResultsContainer';
import MainContainer from './common/MainContainer';

const bannerAd = [<BannerAd key="banner_ad" />];

const Search = ({ params: { searchTerm = '' } }) => (
    <MainContainer pre={bannerAd}>
        <section className="layout-bc layout-bc--watch">
            <SearchResultsContainer searchTerm={searchTerm} />
        </section>
    </MainContainer>
    );

Search.propTypes = {
    params: React.PropTypes.object
};

export default Search;



// WEBPACK FOOTER //
// ./app/page/Search.js